export const NEXT_API_PREFIX = "/next-api";

export const nextApiUrl = (path) => {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${NEXT_API_PREFIX}${normalized}`;
};
